export default "__VITE_ASSET__BWgh1row__"